import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
// import { JobTypes } from '@/core/models/job'
// import { queryGoods } from '@/api/goods'
const JobBaseUrl = '/business/job'
export async function queryJobs(params) {
  const result = await request({
    url: JobBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query jobs failed!')?.page ?? null
}

export async function createJob(job) {
  const result = await request({
    url: JobBaseUrl,
    method: 'POST',
    data: job
  })
  return ResultHandler(result, 'Create job failed!')?.job ?? {}
}

export async function detailJob(jobId) {
  const result = await request({
    url: JobBaseUrl + '/' + jobId,
    method: 'GET'
  })
  // clean job
  const job = ResultHandler(result, 'Get Job detail failed!') ?? null
  return job
}

export async function modifyJob(jobInfo) {
  const result = await request({
    url: JobBaseUrl,
    method: 'PUT',
    data: jobInfo
  })
  return ResultHandler(result, 'Modify job failed!')
}

export async function modifyJobNotes(jobId, notes) {
  const result = await request({
    url: JobBaseUrl + '/' + jobId + '/notes',
    method: 'PUT',
    data: notes
  })
  return ResultHandler(result, 'Modify job notes failed!')
}

export async function modifyGoodsGroup(jobId, groupName, groupInfo) {
  const result = await request({
    url: JobBaseUrl + '/' + jobId + '/group/' + groupName,
    method: 'PUT',
    data: groupInfo
  })
  return ResultHandler(result, 'Modify goods group failed!')
}

export async function completeJob(JobCompleteDo) {
  const result = await request({
    url: JobBaseUrl + '/complete',
    method: 'PUT',
    data: JobCompleteDo
  })
  return ResultHandler(result, 'Complete job failed!')
}

export async function removeJob(jobId) {
  const result = await request({
    url: JobBaseUrl + '/' + jobId,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Delete job failed!')
}

export async function changeJobStatus(jobId, status) {
  const result = await request({
    url: JobBaseUrl + '/' + jobId + '/status',
    method: 'PUT',
    data: { status }
  })
  return ResultHandler(result, 'Delete job failed!')
}

export async function changeJobAssignee(id, assigneeId) {
  const result = await request({
    url: JobBaseUrl,
    method: 'PUT',
    data: {
      id,
      assigneeId
    }
  })
  return ResultHandler(result, 'Assign job failed!')
}

export async function labelGroupPallets(jobId, groupName, start, end) {
  const result = await request({
    url: JobBaseUrl + `/${jobId}/group/${groupName}/label`,
    method: 'GET',
    params: {
      start,
      end
    },
    responseType: 'blob'
  })
  return result
}

export async function labelJobPallets(jobId) {
  const result = await request({
    url: JobBaseUrl + `/${jobId}/labels`,
    method: 'GET',
    responseType: 'blob'
  })
  return result
}

export async function unloadingInstruction(jobId) {
  const result = await request({
    url: JobBaseUrl + `/${jobId}/instruction`,
    method: 'GET',
    responseType: 'blob'
  })
  return result
}
